import { CM_TO_PT } from '../config/constants';

/** Convert centimeters to points (2 decimal precision — Word JS API accepts fractional points). */
export function cmToPt(cm: number): number {
  return Math.round(cm * CM_TO_PT * 100) / 100;
}

/** Convert points to centimeters (floating). */
export function ptToCm(pt: number): number {
  return pt / CM_TO_PT;
}

/** Clamp a number to the inclusive range [min, max]. */
export function clamp(value: number, min: number, max: number): number {
  if (value < min) return min;
  if (value > max) return max;
  return value;
}
